import { h } from 'preact';
import { EmbroideryDetails } from '../multistep/embroidery-details';
import { t } from '../../theme/locales';
const ItemSelection = ({ selectableUnits , selectedItems , remainingCapacity , onToggle , cartItems =[]  })=>{
    if (selectableUnits.length === 0) {
        return h('p', {
            className: 'edit-gift-box__empty'
        }, t('gift_wrapping.steps.select_items.no_items'));
    }
    return h('div', {
        className: 'select-items'
    }, selectableUnits.map((u)=>{
        const checked = selectedItems.includes(u.unitKey);
        const disabled = !checked && typeof remainingCapacity === 'number' && u.effectiveSpace > remainingCapacity;
        const imgSrc = u.item.image;
        var _u_item_title;
        return h('label', {
            key: u.unitKey,
            className: `select-item${disabled ? ' select-item--disabled' : ''}`
        }, [
            h('input', {
                type: 'checkbox',
                className: 'select-item__checkbox',
                checked,
                disabled,
                onChange: ()=>onToggle(u.unitKey)
            }),
            imgSrc ? h('div', {
                className: 'select-item__image-container'
            }, [
                h('img', {
                    src: imgSrc,
                    alt: (_u_item_title = u.item.title) !== null && _u_item_title !== void 0 ? _u_item_title : ''
                })
            ]) : null,
            h('div', {
                className: 'select-item__details'
            }, [
                h('div', {
                    className: 'select-item__title'
                }, u.item.product_title),
                h('div', {
                    className: 'select-item__variant-info'
                }, [
                    h('span', {}, u.item.variant_title)
                ]),
                EmbroideryDetails({
                    item: u.item,
                    cartItems
                }),
                disabled ? h('div', {
                    className: 'select-item__badge select-item__badge--not-selectable'
                }, t('gift_wrapping.steps.select_items.not_selectable')) : null
            ])
        ]);
    }));
};
export default ItemSelection;
